import React from "react";
import { FiLock, FiSlash } from "react-icons/fi";
import { Container, IconCircle, PrincipalText, SecondaryText } from "./styles";
import WhatsappBtn from "./WhatsappButton";
import { useOnboard } from "../../../../hooks/OnboardContext";

interface PlanExpiredProps {
  type?: "blocked" | "cancelled";
  title?: string;
  message?: string;
  buttonText?: string;
}

const PlanExpired: React.FC<PlanExpiredProps> = ({
  type,
  title,
  message,
  buttonText,
}) => {
  const { isSubscriptionBlocked } = useOnboard();

  const resolvedType: "blocked" | "cancelled" =
    type || (isSubscriptionBlocked ? "blocked" : "cancelled");

  const isBlocked = resolvedType === "blocked";

  const defaultTitle = isBlocked
    ? "Assinatura Bloqueada"
    : "Assinatura Cancelada";

  const defaultMessage = isBlocked
    ? "Identificamos uma pendência e o seu acesso aos recursos da plataforma está temporariamente bloqueado. Fale com a equipe do SAF (Serviço de Atendimento ao Fixiter) para normalizar sua assinatura."
    : "Esta assinatura foi encerrada e o acesso às ferramentas foi desativado. Deseja voltar a utilizar a plataforma? Entre em contato com o SAF (Serviço de Atendimento ao Fixiter) para reativar seu plano.";

  const defaultBtnText = isBlocked
    ? "Regularizar via WhatsApp"
    : "Reativar pelo WhatsApp";

  const whatsappUrl = isBlocked
    ? "https://wa.me/5511981669461?text=Ol%C3%A1!%20Gostaria%20de%20resolver%20minhas%20pend%C3%AAncias%20com%20a%20Fix%20it."
    : "https://wa.me/5511981669461?text=Ol%C3%A1!%20Gostaria%20de%20reativar%20minha%20assinatura%20na%20Fix%20it.";

  return (
    <Container>
      <IconCircle $status={resolvedType}>
        {isBlocked ? <FiLock size={38} /> : <FiSlash size={38} />}
      </IconCircle>
      <PrincipalText>{title || defaultTitle}</PrincipalText>
      <SecondaryText>{message || defaultMessage}</SecondaryText>
      <WhatsappBtn text={buttonText || defaultBtnText} url={whatsappUrl} />
    </Container>
  );
};

export default PlanExpired;
